import * as L from 'leaflet';
import { RaceProgressRegistration } from './race_progress_registration';
import { MarkClass } from './mark_class';
import { RaceProgressClassRaw } from './interfaces/race_progress_class_raw.interface';
import { RaceClass } from './race-class';
import { Registration } from './registration';

export type ClassProgressRaw = Omit<ClassProgress, 'competitors' | 'customMapBounds'> & {
  competitors: RaceProgressRegistration[];
  classRules: string;
  customMapBounds: string;
};

export class ClassProgress {
  bestLapUid!: string;
  class!: RaceClass;
  registrations: Array<RaceProgressRegistration> = [];
  marks: Array<MarkClass> = [];

  constructor(obj: RaceProgressClassRaw) {
    this.update(obj);
  }

  update(obj: RaceProgressClassRaw) {
    this.bestLapUid = obj.bestLapUid;
    this.class = new RaceClass(obj.class);
    if (obj.registrations) {
      obj.registrations.forEach((comp) => {
        const issetCompetitor = this.registrations.find((competitor) => competitor.registration.user.cUid === comp.registration.user.cUid);

        if (!issetCompetitor) {
          this.registrations.push(new RaceProgressRegistration(comp));
        } else {
          // Update existing competitor if needed
          issetCompetitor.update(comp);
        }
      });
    }
    this.marks = [];
    if (obj.marks) {
      obj.marks.forEach((mark) => {
        const issetMark = this.marks.find((markItem) => markItem.enterMark === mark.enterMark);
        if (!issetMark) {
          this.marks.push(new MarkClass(mark));
        } else {
          issetMark.update(mark);
        }
      });
    }
  }
}
